/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { usePatch, getAccountCurrencyCode, AdFormat } from '@bingads-webui-campaign/hotel-common-upsert';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { Collapse, TextTitle } from '@bingads-webui-campaign/wizard-jumbo-card';
import { Link, Stack } from '@bingads-webui-react/fabric-control';
import { CampaignName } from './campaign-name';
import { AdgroupName, getAdGroupNameErrorMessage } from './adgroup-name';
import { BaseBid, getBaseBidErrorMessage, getBaseBidTitleDetails } from './base-bid';

const getStyles = () => ({
  AdgroupBasic: {
    '& .section ~ .section': {
      marginTop: '32px',
    },
  },
});


export const AdgroupBasic = (props) => {
  const {
    adgroup,
    bidStrategy,
    campaignName,
    patchAdgroup,
    scenario,
    permissions,
  } = props;
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);
  const setAdgroupName = usePatch(patchAdgroup, 'name');
  const setAdFormat = usePatch(patchAdgroup, 'adFormat');
  const setBaseBid = usePatch(patchAdgroup, 'baseBid');

  const allPanelItems = ['adGroup', 'bidTargets'];
  const [activeKeys, setActiveKeys] = useState(allPanelItems);
  const onCollapseAll = () => {
    if (activeKeys.length) {
      setActiveKeys([]);
    } else {
      setActiveKeys(allPanelItems);
    }
  };

  const getAdGroupTitleDetail = () => {
    const details = [];
    if (adgroup.name.value) {
      details.push(`${i18n.getString(_TL_('Ad group name'))}: ${adgroup.name.value}`);
    }
    if (adgroup.adFormat) {
      const entries = ['HPA', 'PPA'];
      const adFormatValue = _.compact(entries.map((entry) => { if (adgroup.adFormat[entry]) { return entry; } return false; })).join(', ');
      if (adFormatValue) {
        const IsRenameHotelToLodgingEnabled = permissions && permissions.dynamic && permissions.dynamic.IsRenameHotelToLodgingEnabled;
        const detailsString = IsRenameHotelToLodgingEnabled ? `${i18n.getString(_TL_('Property ad format'))}: ${adFormatValue}` : `${i18n.getString(_TL_('Hotel ad format'))}: ${adFormatValue}`;
        details.push(detailsString);
      }
    }
    return details.join(', ');
  };
  const serverContext = useContext(ServerContext);
  const accountCurrencyCode = getAccountCurrencyCode(serverContext);

  return (
    <div className={classnames('adgroup-basic-section', classes.AdgroupBasic)}>
      <Stack horizontalAlign="end" tokens={{ padding: '0 0 12px 0' }}>
        <Link className="jumbo-card-control-all-btn" onClick={onCollapseAll}>{activeKeys.length ? i18n.getString(_TL_('Collapse all')) : i18n.getString(_TL_('Expand all'))}</Link>
      </Stack>
      <Collapse activeKeys={activeKeys} setActiveKeys={setActiveKeys}>
        <Collapse.Panel
          key="adGroup"
          title={<TextTitle titleKey={_TL_('Ad group')} details={getAdGroupTitleDetail()} />}
          error={getAdGroupNameErrorMessage(adgroup.name, adgroup.adFormat)}
        >
          <CampaignName campaignName={campaignName} />
          <AdgroupName setAdgroupName={setAdgroupName} adgroupName={adgroup.name} />
          <AdFormat adFormat={adgroup.adFormat} setAdFormat={setAdFormat} scenario={scenario} permissions={permissions} />
        </Collapse.Panel>
        <Collapse.Panel
          key="bidTargets"
          title={<TextTitle
            titleKey={_TL_('Bid & targets')}
            details={getBaseBidTitleDetails(i18n, adgroup.baseBid, bidStrategy, accountCurrencyCode)}
          />}
          error={getBaseBidErrorMessage({ baseBid: adgroup.baseBid, bidStrategy, serverContext })}
        >
          <BaseBid baseBid={adgroup.baseBid} setBaseBid={setBaseBid} bidStrategy={bidStrategy} />
        </Collapse.Panel>
      </Collapse>
    </div>);
};

AdgroupBasic.propTypes = {
  campaignName: PropTypes.string.isRequired,
  adgroup: PropTypes.shape({}),
  patchAdgroup: PropTypes.func.isRequired,
  scenario: PropTypes.string.isRequired,
  bidStrategy: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      IsRenameHotelToLodgingEnabled: PropTypes.bool,
    }),
  }),
};

AdgroupBasic.defaultProps = {
  adgroup: {},
  permissions: {
    dynamic: {
      IsRenameHotelToLodgingEnabled: false,
    },
  },
};
